export const SET_METRIC_TYPE = 'SET_METRIC_TYPE'
export const RESET_METRIC_TYPE = 'RESET_METRIC_TYPE'
